/**
 * QUEUE API — Wrapper dei REST Liferay allineato a QueuesResourceImpl.java.
 * I 5 metodi CRUD standard vengono da `createCrudApi`. Queue non ha un DTO
 * separato dal modello, quindi `fromDto`/`createToInput` sono l'identità;
 * l'update invia solo `{ name, description }` (PATCH parziale).
 *
 * Contratto backend (rest-openapi.yaml):
 *   - GET    /queues/{groupId}   (+ page, pageSize, sort, search)  -> Page<Queue>
 *   - POST   /queues/{groupId}  QueueInput                          -> Queue
 *   - GET    /queue/{queueId}                                       -> Queue
 *   - PATCH  /queue/{queueId}   QueueInput (name+desc, parziale)    -> Queue
 *   - DELETE /queue/{queueId}                                       -> 200
 */

import type { ServerListParams } from '@crm/shared';
import { createCrudApi } from '../../store/createCrudApi';
import type { Queue, QueueCreatePayload, QueueUpdatePayload } from './queueTypes';

export const queueApi = createCrudApi<
  Queue,
  Queue,
  QueueCreatePayload,
  QueueUpdatePayload,
  ServerListParams
>({
  collection: '/queues',
  single: '/queue',
  fromDto: (dto) => dto,
  createToInput: (payload) => payload,
  updateId: (p) => p.queueId,
  // PATCH parziale: description undefined viene droppato da JSON.stringify e il
  // backend mantiene il valore corrente; '' o valorizzato sovrascrive.
  updateToInput: (p) => ({ name: p.name, description: p.description }),
});
